import React from 'react';
import { UseFormRegister, UseFormReturn } from 'react-hook-form';
import { AddressForm, FormValidation } from '../../global-types/addresses';
import { EnvelopeType } from '../../global-types/envelope';
import { RegionalSchema } from '../../regional-config/regional-config-types';
import { ActionButtonProps, SecondaryActionButtonProps } from '../navigation-buttons/navigation-buttons-types';

export type NavigationProps = {
  secondaryActionButton: SecondaryActionButtonProps;
  primaryActionButton: ActionButtonProps;
};

export type AddressFormFooterButtonsProps = {
  oneToOneProps: NavigationProps;
  oneToManyProps: NavigationProps;
};

export type GetAddressesProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isLoading: boolean;
};

export type AddressFormProps = {
  addClass?: string;
  /** All the return values from the useForm hook */
  formHandlers: UseFormReturn<AddressForm>;
  mockConfig?: RegionalSchema;
  onSkipValidation: (addressesToValidate: FormValidation[]) => void;
  getAddressesProps: GetAddressesProps;
  footerButtonsProps: AddressFormFooterButtonsProps;
};

export type AddressFormActions = {
  isValid: boolean;
  isTouched: boolean;
  isAddressLoading: boolean;
  isAddressFormValid: boolean;
  submitLabel: string;
  goBack: () => void;
  goNext: () => void;
  onHandleLeaveRemainingBlank: () => void;
  goPreviousAddress: () => void;
};

export type AddressBookButtonProps = {
  click: () => void;
};

export type CollapseSectionProps = {
  children: React.ReactNode;
};

export type EnvelopeRadioGroupProps = {
  /** The method from react-hook-form to register the radio cards to the form */
  register: UseFormRegister<AddressForm>;
  envelope: EnvelopeType;
};

export type EnvelopeFormHeaderProps = {
  formTitle: string;
  isRecipientAddress: boolean;
};

export enum DeliveryModes {
  MailToRecipient = 'M',
  ShipToMe = 'S',
  None = '',
}

export type UsStateData = {
  code: string;
  desc: string;
  display_indicator: boolean;
};

export type UsStateOptions = {
  value: string;
  label: string;
};
